<template>
  <div class="project">
    <project-header :project="project"></project-header>

    <div class="project-gallery row">

      <div class="col-12 project-gallery__img"></div>
      <div class="col-12 project-gallery__img"></div>
      <div class="col-12 col-5-sm project-gallery__img"></div>
      <div class="col-12 col-5-sm project-gallery__img"></div>
      <div class="col-12 project-gallery__img project-gallery__img--double"></div>
      <div class="col-12 project-gallery__img"></div>

    </div>

    <project-footer prev="/work/get-clean" next="/work/clean-sound"></project-footer>
  </div>
</template>

<script>
import project from '../../mixins/project'
import projects from '../../projects'

export default {
  name: 'clean-sound',
  data () {
    return {
      project: projects.find(project => project.title === 'Hey Student')
    }
  },
  mixins: [
    project
  ]
}
</script>

<style lang="sass">

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

</style>



// WEBPACK FOOTER //
// HeyStudent.vue?271d3daf